import React from 'react';

// Line icons for manga controls; they inherit the button colour, so disabled and hover states just work.
const Icon = ({ children, size = 20 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        {children}
    </svg>
);

export const ChevronLeftIcon = (props) => <Icon {...props}><path d="M15 18l-6-6 6-6" /></Icon>;
export const ChevronRightIcon = (props) => <Icon {...props}><path d="M9 18l6-6-6-6" /></Icon>;
export const ChevronsLeftIcon = (props) => <Icon {...props}><path d="M11 17l-5-5 5-5" /><path d="M18 17l-5-5 5-5" /></Icon>;
export const ChevronsRightIcon = (props) => <Icon {...props}><path d="M13 17l5-5-5-5" /><path d="M6 17l5-5-5-5" /></Icon>;
export const CloseIcon = (props) => <Icon {...props}><path d="M18 6L6 18" /><path d="M6 6l12 12" /></Icon>;
export const ExpandIcon = (props) => (
    <Icon {...props}>
        <path d="M8 3H5a2 2 0 0 0-2 2v3" />
        <path d="M21 8V5a2 2 0 0 0-2-2h-3" />
        <path d="M3 16v3a2 2 0 0 0 2 2h3" />
        <path d="M16 21h3a2 2 0 0 0 2-2v-3" />
    </Icon>
);
